// TODO replace it after whole structure-editor page is migrated to React
import MarvinController from '@Containers/StructureEditor/Marvin/MarvinController';
import ChemdrawController from '@Containers/StructureEditor/Chemdraw/ChemdrawController';

class StructureEditorInstance {
  _instance;

  set instance(instance) {
    if (instance && !(instance instanceof MarvinController) && !(instance instanceof ChemdrawController)) {
      Logger.error('Trying to set invalid StructureEditor instance', instance);
      return;
    }
    this._instance = instance;
  }

  get instance() {
    return this._instance;
  }
}

export default new StructureEditorInstance();
